import { ThemeModule } from '../../front/lib/ThemeModule';
import { theme } from '../../front/Theme';
import { ThemeMediaSize } from '../../front/defs/types';
export class Cta extends ThemeModule {
    constructor() {
        super(...arguments);
        this.imgWrapperEl = this.getElementById('imgWrapper');
        this.dtImgEl = this.getElementById('dtImage');
        this.mbImgEl = this.getElementById('mbImage');
    }
    init() {
        this.initMobileImage();
    }
    initMobileImage() {
        if (!this.mbImgEl) {
            return;
        }
        theme().attachBreakpointListener(event => {
            if (!this.mbImgEl) {
                return;
            }
            if (event.detail.size <= ThemeMediaSize.Small) {
                this.imgWrapperEl.contains(this.dtImgEl) && this.imgWrapperEl.removeChild(this.dtImgEl);
                this.imgWrapperEl.appendChild(this.mbImgEl);
            }
            else {
                this.imgWrapperEl.contains(this.mbImgEl) && this.imgWrapperEl.removeChild(this.mbImgEl);
                this.imgWrapperEl.appendChild(this.dtImgEl);
            }
        });
    }
}
